export enum AccountType {
  GeneralLedger = 0,
  ThirdPartySubledgerAccount = 1,
  Bank = 2,
  Inventory = 3
}
